import { memo } from "react";
import { Box } from "@mui/material";
import { OrdersListActionMenu } from "../ActionMenu/OrdersListActionMenu";

/**
 * AllOrderActions Component
 *
 * A React functional component that displays the actions available for orders in the "All" tab.
 * This component only shows the Details action via the OrdersListActionMenu.
 *
 * @component
 * @param {Object} props - Component props.
 *
 * @returns {JSX.Element} The rendered AllOrderActions component.
 */
export const AllOrderActions = memo((props) => {
  return (
    <Box display="flex" flexWrap="wrap" gap={2} alignItems="center">
      <OrdersListActionMenu
        menuViewConfig={{ OrderActivityDetails: true }}
        {...props}
      />
    </Box>
  );
});
